"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnstyledTextInput;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _unstyledControlContainer = _interopRequireDefault(require("./unstyledControlContainer"));

var _unstyledInput = _interopRequireDefault(require("./unstyledInput"));

var _unstyledInputIcon = _interopRequireDefault(require("./unstyledInputIcon"));

function UnstyledTextInput(props) {
  var placeholder = props.placeholder,
      value = props.value,
      _props$hint = props.hint,
      hintType = _props$hint.hintType,
      hintMessage = _props$hint.hintMessage,
      disabled = props.disabled,
      maxLength = props.maxLength,
      name = props.name,
      pattern = props.pattern,
      showInputIcon = props.showInputIcon,
      autocomplete = props.autocomplete,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      onKeyPress = props.onKeyPress,
      onKeyUp = props.onKeyUp,
      onKeyDown = props.onKeyDown,
      hint = props.hint;
  var eventHandlers = {
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  };

  var delegateEvent = function delegateEvent(handler, event) {
    return typeof handler === 'function' && handler(event);
  };

  var handleEvents = function handleEvents(eventType) {
    return function (event) {
      return delegateEvent(eventHandlers[eventType], event);
    };
  };

  return _react.default.createElement(_unstyledControlContainer.default, {
    className: hintType,
    disabled: disabled
  }, _react.default.createElement(_unstyledInput.default, (0, _extends2.default)({}, props, {
    placeholder: placeholder,
    value: value,
    disabled: disabled ? 'disabled' : '',
    maxLength: maxLength,
    onChange: handleEvents('onChange'),
    onBlur: handleEvents('onBlur'),
    onFocus: handleEvents('onFocus'),
    onKeyPress: handleEvents('onKeyPress'),
    onKeyUp: handleEvents('onKeyUp'),
    onKeyDown: handleEvents('onKeyDown'),
    name: name,
    pattern: pattern,
    autoComplete: autocomplete,
    type: "text",
    noValidate: "noValidate",
    showInputIcon: showInputIcon,
    hintType: hintType,
    hintMessage: hintMessage
  })), !showInputIcon || !hintMessage || hintType === 'normal' ? null : _react.default.createElement(_unstyledInputIcon.default, {
    hint: hint
  }));
}

UnstyledTextInput.propTypes = {
  value: _propTypes.default.string.isRequired,
  name: _propTypes.default.string,
  pattern: _propTypes.default.string,
  autocomplete: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  maxLength: _propTypes.default.number,
  disabled: _propTypes.default.bool.isRequired,
  showInputIcon: _propTypes.default.bool.isRequired,
  hint: _propTypes.default.shape({
    hintType: _propTypes.default.oneOf(['normal', 'success', 'error', 'info']).isRequired,
    hintMessage: _propTypes.default.string
  }),
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onKeyPress: _propTypes.default.func,
  onKeyUp: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })])
};
UnstyledTextInput.defaultProps = {
  value: '',
  hint: {
    hintType: 'normal'
  },
  disabled: false,
  inputRef: function inputRef() {},
  showInputIcon: false
};